<script setup lang="ts">
    import { useForm } from '@inertiajs/vue3';
    import CompanyTabs from '@/components/companies/CompanyTabs.vue';
    import { ref } from 'vue';
    import DialogForm from '@/components/DialogForm.vue';
    import QueryKey from '@/enums/QueryKey';

    const tabs = ref<InstanceType<typeof CompanyTabs>>();

    const form = useForm({
        // E-conomic
        endpoint: 'plain',
        api_token: '',
        economic_number: '',
        sign_up_date: '',
        website: '',
        economic_accounts: [],

        // Basis
        name: '',
        cvr: '',
        address: '',
        postal_code: '',
        city: '',
        country: '',
        email: '',
        telephone: '',
        mobile_number: '',
        fax_number: '',
        roger_invoices: '',
        roger_receipts: '',
        keepers_email: '',
        employee_default_id: null,
        assistant_id: null,

        // Service
        services: [],
        num_of_vouchers: '',
        has_payments: 0,
        fixed_price: '',
        price_frequency: 'hourly',
        voucher_limit: '',
        report_deadline: '',
        salary_deadline: '',
        vat_frequency: 'missing_info',
        update_frequency: 'missing_info',
        has_e_income: 0,
        day_frequency: [],
        salary_system: '',
        salary_two_step_approval: 0,
        approver_1: '',
        approver_2: '',
        has_kube: 0,
        kube_id: '',
        to_keepers_kube: 0,
        kube_data_field_id: null,

        // Outlay
        outlay_company_id: null,
    });
</script>

<template>
    <DialogForm
        type="create"
        :form="form"
        :route="route('v2.companies.store')"
        :query-key="[QueryKey.COMPANIES]"
        :transform="
            (data) => ({
                ...data,
                vat_frequency: data.vat_frequency === 'missing_info' ? null : data.vat_frequency,
                update_frequency:
                    data.update_frequency === 'missing_info' ? null : data.update_frequency,
            })
        "
        title="companies.js.company_create"
        success-message="companies.created"
        modal-size="sm:max-w-2xl"
        button-text="companies.js.company_create"
    >
        <CompanyTabs
            :form="form"
            ref="tabs"
        />
    </DialogForm>
</template>
